export const SET_USER = 'SET_USER'
export const SIGN_OUT = 'SIGN_OUT'
export const SET_ERR = 'SET_ERR'
export const SET_PASSWORD_RESET_FLAG = 'SET_PASSWORD_RESET_FLAG'
export const SET_ERR_MESSAGE = 'SET_ERR_MESSAGE'
export const CHANGE_USER_PROFILE = 'CHANGE_USER_PROFILE'
export const CHANGE_USER_PICTURE = 'CHANGE_USER_PICTURE'

export const LOAD_RESPONSE = 'LOAD_RESPONSE'
export const SET_LOADING = 'SET_LOADING'

export const GET_ALL_COMPANIES = 'GET_ALL_COMPANIES'
export const ADD_COMPANY = 'ADD_COMPANY'
export const CHANGE_COMPANY = 'CHANGE_COMPANY'
export const DELETE_COMPANY = 'DELETE_COMPANY'
export const SET_ACTIVE_COMPANY = 'SET_ACTIVE_COMPANY'

export const GET_ALL_DIVISIONS = 'GET_ALL_DIVISIONS'
export const ADD_DIVISION = 'ADD_DIVISION'
export const CHANGE_DIVISION = 'CHANGE_DIVISION'
export const DELETE_DIVISION = 'DELETE_DIVISION'
export const SET_ACTIVE_DIVISION = 'SET_ACTIVE_DIVISION'

export const GET_ALL_DEPARTMENTS = 'GET_ALL_DEPARTMENTS'
export const ADD_DEPARTMENT = 'ADD_DEPARTMENT'
export const CHANGE_DEPARTMENT = 'CHANGE_DEPARTMENT'
export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT'
export const SET_ACTIVE_DEPARTMENT = 'SET_ACTIVE_DEPARTMENT'

export const GET_ALL_RANKS = 'GET_ALL_RANKS'
export const ADD_RANK = 'ADD_RANK'
export const CHANGE_RANK = 'CHANGE_RANK'
export const DELETE_RANK = 'DELETE_RANK'
export const SET_ACTIVE_RANK = 'SET_ACTIVE_RANK'

export const GET_ALL_PLANTS = 'GET_ALL_PLANTS'
export const ADD_PLANT = 'ADD_PLANT'
export const CHANGE_PLANT = 'CHANGE_PLANT'
export const DELETE_PLANT = 'DELETE_PLANT'
export const SET_ACTIVE_PLANT = 'SET_ACTIVE_PLANT'

export const GET_APPROVAL_PROFILES = 'GET_APPROVAL_PROFILES'
export const ADD_APPROVAL_PROFILE = 'ADD_APPROVAL_PROFILE'
export const CHANGE_APPROVAL_PROFILE = 'CHANGE_APPROVAL_PROFILE'
export const DELETE_APPROVAL_PROFILE = 'DELETE_APPROVAL_PROFILE'
export const SET_ACTIVE_APPROVAL_PROFILE = 'SET_ACTIVE_APPROVAL_PROFILE'

export const GET_APPROVAL_LIMITS = 'GET_APPROVAL_LIMITS'
export const ADD_APPROVAL_LIMIT = 'ADD_APPROVAL_LIMIT'
export const CHANGE_APPROVAL_LIMIT = 'CHANGE_APPROVAL_LIMIT'
export const DELETE_APPROVAL_LIMIT = 'DELETE_APPROVAL_LIMIT'

export const GET_APPROVAL_USERS = 'GET_APPROVAL_USERS'
export const ADD_APPROVAL_USER = 'ADD_APPROVAL_USER'
export const CHANGE_APPROVAL_USER = 'CHANGE_APPROVAL_USER'
export const DELETE_APPROVAL_USER = 'DELETE_APPROVAL_USER'
export const BLOCK_APPROVAL_USER = 'BLOCK_APPROVAL_USER'
export const SET_ACTIVE_APPROVAL_USER = 'SET_ACTIVE_APPROVAL_USER'

export const GET_USER_DEVICES = 'GET_USER_DEVICES'
export const BLOCK_USER_DEVICE = 'BLOCK_USER_DEVICE'

export const GET_WORKFLOW = 'GET_WORKFLOW'
export const ADD_WORKFLOW = 'ADD_WORKFLOW'
export const CHANGE_WORKFLOW = 'CHANGE_WORKFLOW'
export const DELETE_WORKFLOW = 'DELETE_WORKFLOW'
export const SET_ACTIVE_WORKFLOW = 'SET_ACTIVE_WORKFLOW'

export const GET_PR_REPORT = 'GET_PR_REPORT'
export const GET_PO_REPORT = 'GET_PO_REPORT'

export const GET_PENDING_PR = 'GET_PENDING_PR'
export const GET_PENDING_PO = 'GET_PENDING_PO'
export const GET_TOTAL_USERS = 'GET_TOTAL_USERS'
export const GET_LOGIN_USERS = 'GET_LOGIN_USERS'

export const GET_ALL_ADMIN = 'GET_ALL_ADMIN'
export const SET_ACTIVE_ADMIN = 'SET_ACTIVE_ADMIN'
export const ADD_ADMIN = 'ADD_ADMIN'
export const CHANGE_ADMIN = 'CHANGE_ADMIN'
export const DELETE_ADMIN = 'DELETE_ADMIN'
export const GET_ACCESSIBLE_MENU = 'GET_ACCESSIBLE_MENU'
export const SET_ACCESSIBLE_MENU = 'SET_ACCESSIBLE_MENU'
export const CHANGE_ACCESSIBLE_MENU = 'CHANGE_ACCESSIBLE_MENU'

export const GET_ALL_MENU_ITEMS = 'GET_ALL_MENU_ITEMS'
export const GET_MENU_LIST_OPTIONS = 'GET_MENU_LIST_OPTIONS'

export const GET_CURRENCY = 'GET_CURRENCY'
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY'
export const DELETE_CURRENCY = 'DELETE_CURRENCY'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js